import * as React from "react";
import { SelfServiceClient } from "../api/ApiClient";
import Spinner from "../components/Spinner";
import { UserContext } from "../context/UserContext";
import { Consumption } from "./Consumption";
import { Contact } from "./Contact";
import { ElavtalContainer } from "./ElavtalContainer";
import { Invoices } from "./Invoices";

interface Props {}

interface State {
  status: Status;
}

enum Status {
  FETCHING,
  ERROR,
  DONE,
}

export class SelfServiceContainer extends React.Component<Props, State> {
  static contextType = UserContext;
  context!: React.ContextType<typeof UserContext>;

  private readonly selfServiceClient: SelfServiceClient =
    new SelfServiceClient();

  state = {
    status:
      !this.context || !this.context.customer ? Status.FETCHING : Status.DONE,
  };

  async componentDidMount() {
    try {
      this.selfServiceClient.setToken(this.context.token);

      if (!this.context.customer) {
        this.setState({ status: Status.FETCHING });
        let customer = await this.selfServiceClient.customer(
          window.location.href
        );
        this.context.setCustomer(customer);
        this.setState({ status: Status.DONE });
      } else {
        this.setState({ status: Status.DONE });
      }

      if (true /*!this.context.elavtal || this.context.elavtal.length == 0*/) {
        let elavtal = await this.selfServiceClient.elavtal(
          window.location.href
        );

        if (elavtal) {
          this.context.setElavtal(elavtal);
        }
      }
    } catch (error) {
      if (error.status == 404) {
        console.error("Customer not found", { error });
        this.setState({ status: Status.DONE });
      } else {
        console.error("Failed to fetch customer", { error });
        this.setState({ status: Status.ERROR });
      }
    }
  }

  render() {
    return (
      <div>
        {this.state.status == Status.ERROR && (
          <p>
            Något gick tyvärr fel när vi skulle hämta information om din el.
          </p>
        )}
        {this.state.status == Status.FETCHING && <Spinner></Spinner>}
        {this.state.status == Status.DONE && !this.context.customer && (
          <React.Fragment>
            <h2>Hej</h2>
            <p>
              Va kul att du hittat hit. Det verkar som att du inte valt att bli kund ännu och måste fortsätta tänka på el. Det är snabbt löst,
              klicka på knappen nedan, det tar knappt en minut.
            </p>
            <a
              className="btn btn-primary btn-lg mt-4 mb-2"
              href="/bli-kund"
              role="button">
              Bli kund
            </a>
          </React.Fragment>
        )}
        {this.state.status == Status.DONE && this.context.customer && (
          <React.Fragment>
            <Contact />
            <ElavtalContainer />
            <Consumption />
            <Invoices />
          </React.Fragment>
        )}
      </div>
    );
  }
}
